import React, { useEffect, useState } from 'react';
import classes from './app.module.scss';
import Call from '../call/call';
import CallStart from '../call-start/call-start';
import { ReactComponent as Logo } from '../../img/tricolor.svg';
import cn from 'classnames';
import { isMobile } from 'react-device-detect';
import CallError from '../call-error/call-error';
import LogCollector from '../../controllers/log-collector';
import { customAlphabet } from 'nanoid/non-secure';
const nanoid = customAlphabet('1234567890abcdef', 10);

const App = () => {
  const [started, setStarted] = useState(false);
  const [inputDevice, setInputDevice] = useState('default');
  const [outputDevice, setOutputDevice] = useState('default');
  const [isError, setIsError] = useState(false);
  const [sessionId] = useState(nanoid());
  const [logCollector] = useState(new LogCollector(sessionId));

  useEffect(() => {
    appHeight();
    window.addEventListener('resize', appHeight);

    return () => {
      window.removeEventListener('resize', appHeight);
    }
  }, []);

  useEffect(() => {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('ID1', isMobile ? 'mob' : 'web');
    window.history.replaceState({}, '', currentUrl);
    // eslint-disable-next-line
  }, [isMobile]);

  const appHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty('--app-height', `${window.innerHeight}px`);
  }

  const getComponent = () => {
    if (isError) {
      return <CallError />;
    }

    if (started) {
      return (
        <Call
          sessionId={sessionId}
          logCollector={logCollector}
          inputDevice={inputDevice}
          outputDevice={outputDevice}
          setStarted={setStarted}
          setIsError={setIsError}
        />
      );
    }

    return (
      <CallStart
        logCollector={logCollector}
        inputDevice={inputDevice}
        outputDevice={outputDevice}
        onChangeInputDevice={setInputDevice}
        onChangeOutputDevice={setOutputDevice}
        onCall={() => setStarted(true)}
      />
    );
  };

  return (
    <div
      className={cn(classes.wrapper, {
        [classes.wrapper_mobile]: isMobile,
        [classes.wrapper_desktop]: !isMobile,
      })}
    >
      <div
        className={classes.app}
      >
        <div className={classes.main}>
          <div
            className={cn(classes.main__logo, classes.logo)}
            onClick={() => window.open('https://tricolor.ru/', '_blank')}
          >
            <span className={classes.logo__label}>
              интернет-звонок
            </span>
            <Logo className={classes.logo__image}/>
          </div>
          <div className={classes.main__content}>
            {getComponent()}
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;